import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { CopyOutlined } from '@ant-design/icons-vue';
import useClipboard from 'vue-clipboard3';
import { notify } from '@kyvg/vue3-notification';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableCopy',
  props: {
  value: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { toClipboard } = useClipboard();
const copy = async () => {
  try {
    // 复制
    await toClipboard(props.value);
    notify({ text: '复制成功', type: 'success' });
  } catch (e) {
    notify({ text: '复制失败', type: 'error' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("a", { onClick: copy }, [
      _createVNode(_unref(CopyOutlined)),
      _createTextVNode(" " + _toDisplayString(__props.value), 1)
    ])
  ]))
}
}

})